var map = {
	"./ArtBronze.png": 47751,
	"./ArtGold.png": 73475,
	"./ArtSilver.png": 43229,
	"./EntertainmentBronze.png": 34393,
	"./EntertainmentGold.png": 37027,
	"./EntertainmentSilver.png": 72851,
	"./GeographyBronze.png": 20715,
	"./GeographyGold.png": 59365,
	"./GeographySilver.png": 17854,
	"./HistoryBronze.png": 13045,
	"./HistoryGold.png": 68412,
	"./HistorySilver.png": 98982,
	"./NumberOne.png": 25834,
	"./ScienceBronze.png": 9159,
	"./ScienceGold.png": 68241,
	"./ScienceSilver.png": 5714,
	"./ScoreBronze.png": 44869,
	"./ScoreGold.png": 96989,
	"./ScoreSilver.png": 5417,
	"./trivialmania.png": 27124
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65016;